import { render } from "./ProfessionalPage.vue?vue&type=template&id=a293e2c2"
import script from "./ProfessionalPage.vue?vue&type=script&lang=js"
export * from "./ProfessionalPage.vue?vue&type=script&lang=js"
script.render = render

export default script